import { useEffect, useState, useCallback } from "react";
import { getLotStatuses } from "../api/lotStatusService";

export function useLotStatuses(query) {
  const {
    page,
    pageLimit,
    filters: { code, lotStatusType },
  } = query;

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let ignore = false;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const res = await getLotStatuses(query);
        if (!ignore) {
          setData(res.items);
          setTotal(res.total);
        }
      } catch (e) {
        if (!ignore) setError(e?.message || "Ошибка при получении статусов");
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, [page, pageLimit, code, lotStatusType, reloadKey]); // ← reloadKey добавлен

  const reload = useCallback(() => setReloadKey((k) => k + 1), []);

  return { data, total, loading, error, reload };
}
